import React, { Component } from 'react'
import styled from 'styled-components'
import { CSSTransition } from 'react-transition-group'

const StyledCalendarSection = styled.div`
  width: calc(100% + 2em);
  margin: 0 -1em;
  height: auto;
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  background-color: ${({ theme, accordionColor }) =>
    accordionColor || theme.darkGrey};

  &.accordion-enter {
    max-height: 0;
    overflow-x: hidden;
  }

  &.accordion-enter-active {
    max-height: 100em;
    overflow-x: auto;
    transition: 2.5s;
  }

  &.accordion-exit {
    max-height: 0;
    overflow-x: hidden;
    transition: 0.5s;
  }

  &.accordion-exit-active {
    max-height: 0;
    overflow-x: hidden;
    transition: 0.5s;
  }
`

const StyledChildrenContainer = styled.div`
  padding: 1em 0;
  width: 100%;
`

class CalendarContent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
      isOpen: props.isOpen
    }
  }

  componentWillReceiveProps(newProps) {
    const { isOpen } = this.props
    if (isOpen) {
      this.setState({ show: true })
    } else {
      this.setState({ show: false })
    }
  }

  render() {
    const { accordionColor, children, isOpen, showAccordion } = this.props
    if (!showAccordion) {
      return null
    } else {
      return (
        <CSSTransition
          in={Boolean(isOpen)}
          timeout={2500}
          classNames="accordion"
          unmountOnExit
          onExited={() => {}}>
          <StyledCalendarSection accordionColor={accordionColor}>
            <StyledChildrenContainer>{children}</StyledChildrenContainer>
          </StyledCalendarSection>
        </CSSTransition>
      )
    }
  }
}

export default CalendarContent



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Calendar/CalendarContent.js